import userTicketsComponent from './user-tickets.component';

const userTicketsModule = angular.module('userTickets', [
])
  .component('userTickets', userTicketsComponent)
  .name;

export default userTicketsModule;
